import { Stack, ThemeProvider } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

interface Props {
  modalState: UseModalState;
  onCancelDeletion: () => Promise<void> | void;
  onLogout: () => Promise<void> | void;
  isLoading: boolean;
}

export function AccountDeletionRequestedDialog(props: Props) {
  const { modalState, onCancelDeletion, onLogout, isLoading } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet modalState={modalState}>
        <BottomSheetIllustrationContent
          illustrationType="warning"
          title="Account deletion pending"
          description="Your account is scheduled for deletion. Cancel the request to continue using your account, or log out."
        />
        <DialogFooter orientation="vertical">
          <Stack spacing={2} sx={{ width: "100%" }}>
            <LoadingButton
              fullWidth
              variant="contained"
              size="large"
              isLoading={isLoading}
              aria-label="Cancel account deletion"
              onClick={async () => {
                await onCancelDeletion();
              }}
            >
              Cancel deletion
            </LoadingButton>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              disabled={isLoading}
              aria-label="Log out"
              onClick={async () => {
                await onLogout();
              }}
            >
              Log out
            </Button>
          </Stack>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
